/**
 * @file: The Escape key and the exit of the calendar page.
 *
 * The calendar is a route. The page starts when the component mounts, and it
 * ends when the operator leaves the route. A new scene id in the URL also
 * mounts a new component, so a page never starts two times.
 */

export class PageManager {
  constructor (controller) {
    this.controller = controller
    // A save answer can come after the operator left. It then must not open
    // the panel again.
    this.hasLeft = false
    this._escapeHandler = null
  }

  /**
   * Listen for the Escape key. Called from $onInit.
   *
   * Escape closes only the top element. It does not leave the page. The
   * calendar is a route, and a keypress must not navigate.
   *
   * The report is above the grid, so the code closes it first. To close the
   * panel below the report would change the page behind a card that the
   * operator still reads.
   */
  enter () {
    this._escapeHandler = (event) => {
      if (event.key !== 'Escape') return

      const { preflightManager, stateManager } = this.controller

      if (preflightManager.preflight) {
        event.stopPropagation()
        preflightManager.closePreflight()
        this.controller._$scope.$applyAsync()
        return
      }

      if (!stateManager.inspecting) return

      event.stopPropagation()
      stateManager.closeInspector()
      this.controller._$scope.$applyAsync()
    }
    document.addEventListener('keydown', this._escapeHandler)
  }

  /**
   * Stop the Escape listener, and close the panel and the report. Called from
   * $onDestroy.
   *
   * The page goes in any case, so the panel closes without a question about
   * unsaved edits.
   */
  leave () {
    document.removeEventListener('keydown', this._escapeHandler)
    this._escapeHandler = null
    this.hasLeft = true

    this.controller.stateManager.clearInspector()
    this.controller.preflightManager.closePreflight()
  }
}
